export default "__VITE_ASSET__BqdIcEsK__"